import { render, staticRenderFns } from "./Limitations.vue?vue&type=template&id=4f250fe9&"
import script from "./Limitations.vue?vue&type=script&lang=js&"
export * from "./Limitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports